const _excluded = ["isOpen", "onRequestClose", "title", "variant", "children", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { useId } from "@react-aria/utils";
import { BaseModal } from "../BaseModal/BaseModal";
import { cx } from "../../helpers/utils/cx";
import { filterDataAttributes } from "../../helpers/utils/props";
export function Dialog(_ref) {
  let {
      isOpen,
      onRequestClose,
      title,
      variant = "default",
      children,
      size
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const titleId = useId();
  const dataAttributes = filterDataAttributes(rest);
  return /*#__PURE__*/React.createElement(BaseModal, _extends({
    "aria-labelledby": titleId,
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    allowCloseOnOutsideClick: variant === "default",
    role: variant === "alert" ? "alertdialog" : "dialog"
  }, dataAttributes), /*#__PURE__*/React.createElement("div", {
    className: cx("max-h-[80vh] max-w-md flex flex-col bg-layer-floor-2 rounded-lg", [size === "custom" ? "max-w-[calc(100vw-1rem)]" : "max-w-md"])
  }, /*#__PURE__*/React.createElement(DialogHeader, {
    title: title,
    variant: variant,
    titleId: titleId
  }, variant === "default" ? /*#__PURE__*/React.createElement(BaseModal.Close, {
    onClose: onRequestClose,
    autoFocus: true
  }) : null), children));
}
function DialogHeader(_ref2) {
  let {
    title,
    variant,
    titleId,
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-6 px-6 pt-5 pb-4 items-baseline", variant === "alert" ? "justify-center" : "justify-between"),
    "data-kalep-comp": "dialog/header"
  }, title && /*#__PURE__*/React.createElement("span", {
    id: titleId,
    className: cx("bolt-font-heading-s-accent text-primary")
  }, title), children);
}
function DialogFooter(_ref3) {
  let {
    children
  } = _ref3;
  const [primaryAction, secondaryAction, ...remainingActions] = React.Children.toArray(children);
  return /*#__PURE__*/React.createElement(BaseModal.Footer, null, /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-4 flex-col sm:flex-row-reverse sm:justify-between")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-4 flex-col sm:flex-row-reverse")
  }, primaryAction, secondaryAction), remainingActions.length > 0 && /*#__PURE__*/React.createElement("div", null, remainingActions)));
}
Dialog.Content = BaseModal.Content;
Dialog.Footer = DialogFooter;